import React from 'react';
import Text from 'image/Text-1.png';
import TextGradient from 'components/TextGradient';
import './EgyptPage.scss';


function EgyptPage(props) {
    return (
        <div className='egypt-page'>

                <TextGradient text={Text}/>

        </div>
    );
}

export default EgyptPage;